import React, {useContext, useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import { TextField, Divider } from '@mui/material';
import { inputOnlyNumbers } from '../../../utils/CommonUtilities';
import Autocomplete from '@mui/material/Autocomplete';
import {v4 as uuidv4} from 'uuid';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function ManageTagsDialog(props) {
    const [loading, setLoading] = useState(false);
    const auth = useContext(AuthContext);
    const { notificationSuccess, notificationError } = useNotification();
    const [idEntita, setIdEntita] = useState('');
    const [city, setCity] = useState('');
    const [descrizione, setDescrizione] = useState('');
    const [tickerList, setTickerList] = useState([]);
    const [tickerEmergenzaList, setTickerEmergenzaList] = useState([]);

    const [originalDescrizione, setOriginalDescrizione] = useState('');
    const [originalTickerList, setOriginalTickerList] = useState([]);
    const [originalTickerEmergenzaList, setOriginalTickerEmergenzaList] = useState([]);

    useEffect(() => {
        async function init(){
            if(props.openManageTagsDialog==='mod'){
                setIdEntita(props.lastCellData?.idEntita.S);
                setCity(props.lastCellData?.city.S);
                setDescrizione(props.lastCellData?.descrizione.S);

                setOriginalDescrizione(props.lastCellData?.descrizione.S);
                if(props.lastCellData?.tickerList?.SS.length > 0){
                    if(props.lastCellData?.tickerList?.SS.length === 1 && props.lastCellData?.tickerList?.SS[0] === ""){
                        setTickerList([]);
                        setOriginalTickerList([]);
                    }else{
                        let arrValues = [];
                        for (let index = 0; index < props.lastCellData?.tickerList?.SS.length; index++) {
                            let found = props.tickers.find(item => item.id === props.lastCellData?.tickerList?.SS[index]);
                            if(found)arrValues.push(found);
                        }
                        setTickerList(arrValues);
                        setOriginalTickerList(arrValues);
                    }
                }else{
                    setTickerList([]);
                    setOriginalTickerList([]);
                }
                if(props.lastCellData?.tickerEmergenzaList?.SS.length > 0){
                    if(props.lastCellData?.tickerEmergenzaList?.SS.length === 1 && props.lastCellData?.tickerEmergenzaList?.SS[0] === ""){
                        setTickerEmergenzaList([]);
                        setOriginalTickerEmergenzaList([]);
                    }else{
                        let arrValues = [];
                        for (let index = 0; index < props.lastCellData?.tickerEmergenzaList?.SS.length; index++) {
                            let found = props.tickersEmergenza.find(item => item.id === props.lastCellData?.tickerEmergenzaList?.SS[index]);
                            if(found)arrValues.push(found);
                        }
                        setTickerEmergenzaList(arrValues);
                        setOriginalTickerEmergenzaList(arrValues);
                    }
                }else{
                    setTickerEmergenzaList([]);
                    setOriginalTickerEmergenzaList([]);
                }
            }else{
                setIdEntita('');
                setCity('');
                setDescrizione('');
                setTickerList([]);
                setOriginalTickerList([]);
                setTickerEmergenzaList([]);
                setOriginalTickerEmergenzaList([]);
            }
        }
        init()
    },[props.openManageTagsDialog])

    const insTag = async() => {
        try {
            setLoading(true);

            const data = {
                idEntita: uuidv4(),
                descrizione: descrizione,
                tickerList: tickerList.map(el => el.id),
                tickerEmergenzaList: tickerEmergenzaList.map(el => el.id),
                city: props.city
            }

            const axiosParams = {
                url: '/ins-tag',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data
            };

            await axios(axiosParams);
            notificationSuccess('Tag Aggiunto');

            await props.getTags();
            props.handleCloseManageTagsDialog();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    const modTag = async() => {
        try {
            setLoading(true);
            let areTickerListEqual = checkEqual(tickerList.map(el => el.id), originalTickerList.map(el => el.id));
            let areTickerEmergenzaListEqual = checkEqual(tickerEmergenzaList.map(el => el.id), originalTickerEmergenzaList.map(el => el.id)); 
            
            const data = {
                descrizione: descrizione === originalDescrizione ? '' : descrizione,
                tickerList: areTickerListEqual ? false : tickerList.map(el => el.id),
                tickerEmergenzaList: areTickerEmergenzaListEqual ? false : tickerEmergenzaList.map(el => el.id),
            }
            
            const dataToPass = {
                idEntita: idEntita,
                city: city,
                areTickerListEqual,
                areTickerEmergenzaListEqual,
                tickerList: tickerList.map(el => el.id),
                tickerEmergenzaList: tickerEmergenzaList.map(el => el.id),
                originalTickerList: originalTickerList.map(el => el.id),
                originalTickerEmergenzaList: originalTickerEmergenzaList.map(el => el.id),
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else if(element === 'tickerList'){
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"SS": data[element].length === 0 ? [""] :[...data[element]]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`; 
                }else if(element === 'tickerEmergenzaList'){
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"SS": data[element].length === 0 ? [""] :[...data[element]]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`; 
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }

            const axiosParams = {
                url: '/mod-tag',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: dataToPass
            };

            const response = await axios(axiosParams);
            notificationSuccess('Tag Aggiornato');

            let newOriginalItems = response.data.responseUpdate.Attributes

            setOriginalDescrizione(newOriginalItems?.descrizione?.S || '');
            setOriginalTickerList(newOriginalItems?.tickerList?.SS || []);
            setOriginalTickerEmergenzaList(newOriginalItems?.tickerEmergenzaList?.SS || []);

            await props.getTags();
            props.handleCloseManageTagsDialog();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    function checkEqual(a, b) {
        // If lengths of array are not equal means
        // array are not equal
        if (a.length !== b.length) return false;
        a.sort();
        b.sort();
        for (let i = 0; i < a.length; i++){
            if (a[i] !== b[i]){
                return false;
            }
        }
    
        // If all elements were same.
        return true;
    }

    return (
        <Dialog className="dialog-mod-tag" open={props.openManageTagsDialog} onClose={props.handleCloseManageTagsDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{props.openManageTagsDialog === 'ins' ? 'Inserisci tag' : props?.lastCellData?.descrizione?.S}</DialogTitle>
            <DialogContent>
                <div className='dialog-tag-wrapper'>
                    <div className='dialog-tag-wrapper-section'>
                        <div className="dialog-tag-fields">
                            <TextField
                                className="dialog-descrizione required-field-bg"
                                id="dialog-descrizione"
                                label="Descrizione"
                                type="text"
                                value={descrizione}
                                onChange={(event) => {
                                    setDescrizione(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                            />
                        </div>
                    </div>
                    
                        <Divider variant="middle"/>
                    <div className="dialog-tag-fields">
                        <Autocomplete
                            className="tickerList-autocomplete"
                            multiple
                            options={props.tickers}
                            disableCloseOnSelect
                            value={tickerList}
                            limitTags={5}
                            onChange={(event, newValue) => {
                                setTickerList([...newValue]);
                            }}
                            getOptionLabel={(option) => `${option.label}`}
                            style={{ minWidth: 250 }}
                            renderInput={(params) => (
                                <TextField
                                    className="tags-autocomplete-textfield"
                                    {...params}
                                    label="Tickers"
                                    variant="standard"
                                />
                            )}
                        />

                        <Autocomplete
                            className="tickerEmergenzaList-autocomplete"
                            multiple
                            options={props.tickersEmergenza}
                            disableCloseOnSelect
                            value={tickerEmergenzaList}
                            limitTags={5}
                            onChange={(event, newValue) => {
                                setTickerEmergenzaList([...newValue]);
                            }}
                            getOptionLabel={(option) => `${option.label}`}
                            style={{ minWidth: 250 }}
                            renderInput={(params) => (
                                <TextField
                                    className="tags-autocomplete-textfield"
                                    {...params}
                                    label="TickersEmergenza"
                                    variant="standard"
                                />
                            )}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={() => props.openManageTagsDialog === 'ins' ? insTag() : modTag()}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseManageTagsDialog}>
                    Esci
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ManageTagsDialog